<template>
  <div class="login">
    <div class="login-main">
      <h1>欢迎登录诊断宝运营平台</h1>
      <el-tabs v-model="activeName">
        <el-tab-pane label="账号密码登录" name="second">
          <Username />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Username from "./username";
export default {
  components: {
    Username,
  },
  data() {
    return {
      activeName: "second",
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  background: url('../../../assets/imgs/zzzd/分组 12.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.login-main {
  width: 522px;
  height: 497px;
  background: #fff;
  padding: 50px 112px 0;
  position: absolute;
  top: 150px;
  right: 150px;
  h1 {
    width: 100%;
    margin: 0 0 39px;
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 25px;
  }
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__nav {
    width: 100%;
    display: flex;
    .el-tabs__item {
      flex: 1;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 20px;
    }
  }
  .el-tabs__content {
    width: 100%;
  }
  .verificationCode .el-form button {
    background: #1444D4;
    border: #1444D4;
  }
  .el-tabs__item:hover {
    color: #1444D4;
    cursor: pointer;
  }
  .el-tabs__item.is-active {
    color: #1444D4;
  }
  .el-tabs__active-bar {
    background-color: #1444D4;
  }
  /deep/.el-form-item__content{
    margin-left: 0 !important;
  }
}
</style>
